/** Loads PANE Objects into the Application stage
    @abstract
    @class
*/
export default class PANELOADER {
    page;
    model;
    /** Load a collection of PANE's into the MAIN UI */
    constructor(page, model) {
        this.page = page;
        this.model = model;
    }
    /** initialize Content Pane
        @param {string} name PANE Name
        @returns {Promise} Promise to create a PANE
    */
    initializePane(name) {
        return this.page.chain(() => {
            this.page.horizontal.center.empty(false);
            this.page.horizontal.center.el.scrollTo(0, 0);
            this.paneSwitch(name);
        });
    }
}
